// extracted by mini-css-extract-plugin
module.exports = {"text_color_green":"CheckoutPromoItemFooter_text_color_green__28NYP","promoItemFooter":"CheckoutPromoItemFooter_promoItemFooter__2R7Es"};